import { FC, memo } from 'react'

import { Tab, Tabs } from 'src/components/molecules'

export type DisplayProjectTabType = 'all' | 'myAssignment'

type Props = {
  selected: DisplayProjectTabType
  onSelect: (selected: DisplayProjectTabType) => void
  className?: string
}

export const DisplayProjectTypeTabs: FC<Props> = memo(({ selected, onSelect, className }) => {
  return (
    <div className={className}>
      <Tabs size="s" isLightBackground className="tw-ml-10">
        <Tab
          size="s"
          isSelected={selected === 'all'}
          text="すべて"
          onClick={() => onSelect('all')}
          className="tw-z-10"
        />
        <Tab
          size="s"
          isSelected={selected === 'myAssignment'}
          text="アサイン済"
          onClick={() => onSelect('myAssignment')}
          className="tw-z-10"
        />
      </Tabs>
    </div>
  )
})
